import ReactDOM from 'react-dom/client'
import App from './App.tsx'

declare global {
  interface Window {
    env: {
      API_ENDPOINT: string
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
